<template>
  <div>
    <el-form :inline="true" class="style1">
      <!-- <el-form-item>
                <el-button class="el-icon-refresh" type="text" @click="refreshData">{{$t("general.refresh")}}
                </el-button>
      </el-form-item>-->
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">{{$t("general.add")}}
        </el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" stripe highlight-current-row border style="width: 100%"
      :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('healthIns2.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns2.change_post')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.change_post}}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns2.change_address')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.change_address1 }}</span>
          <span>{{ scope.row.change_address2 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns2.change_date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.movingDate }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('healthIns2.remark')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="350">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}</el-button>
          <el-button size="mini" type="success" icon="el-icon-success" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}</el-button>
          <!-- <el-button size="mini" type="success" icon="el-icon-view" @click="preview(scope.$index, scope.row)" plain>
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!--adding new-->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="70%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition">

        <el-input type="hidden" v-model="ruleForm.id" />
        <el-collapse accordion>
          <el-collapse-item :title="$t('healthIns2.insured_info')" name="1" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-select v-model="ruleForm.employee_id" style="margin-left:10px;width: 185px" size="mini"
                      @change="employeeIdSelected" :placeholder="$t('general.select')">
                      <el-option v-for="item in empList" :key="item.id" :label="item.employee_id"
                        :value="item.employee_id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.mynum')" prop="mynum" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.mynum" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.mynum')" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.name')" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.birthday')" prop="birthday" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.birthday" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns2.birthday')"
                      readonly></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-form-item :label="$t('healthIns2.before_address')" prop="before_address1" style="margin-left:50px">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.address" size="mini"
                  style="margin-left:10px;width: 690px;" :placeholder="$t('healthIns2.before_address')" readonly>
                </el-input>
              </el-form-item>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.change_post')" prop="change_post" style="margin-left:50px">
                    <el-input @change="searchLocation" prefix-icon="el-icon-edit" v-model="ruleForm.change_post"
                      size="mini" style="margin-left:10px;width: 185px" placeholder="000-0000" :maxlength="8">
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.change_address_pref')" prop="change_address1"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.change_address1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.change_address_pref')">
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.change_date')" prop="movingDate" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.movingDate" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns2.before_address')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.change_address')" prop="change_address2"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.change_address2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.change_address')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-form-item :label="$t('healthIns2.change_address_pho')" prop="change_address_frgn"
                style="margin-left:50px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.change_address_frgn" size="mini"
                  style="margin-left:10px;width: 690px" :placeholder="$t('healthIns2.change_address_pho')"></el-input>
              </el-form-item>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.remark')" prop="remark" style="margin-left:50px">
                    <el-select v-model="ruleForm.remark" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in remark" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.arrange_num')" prop="arrange_num" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.arrange_num" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000" :maxlength="8"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.other')" prop="other" v-if="ruleForm.remark === 'その他'"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.other" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.other')"></el-input>
                    <el-button class="el-icon-info" type="text" @click="otherHint" v-if="ruleForm.remark === 'その他'">
                    </el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--Spouse Input -->
          <el-collapse-item :title="$t('healthIns2.spouse')" name="2" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.s_mynum')" prop="s_mynum" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.mynum_family" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.mynum')" readonly="readonly">
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.s_name')" prop="s_name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name_family" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.s_name')" readonly="readonly">
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.birthday')" prop="s_birthday" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.birthday_family" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns2.birthday')"
                      readonly="readonly">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.s_name_frgn')" prop="s_first_name_kn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name_frgn_family" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.s_name_frgn')"
                      readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="22">
                <div>
                  <el-form-item :label="$t('healthIns2.together')" prop="s_change_address_frgn" label-width="440px"
                    style="margin-left:50px">
                    <el-switch v-model="ruleForm.together" style="margin-left:40px;" active-color="rgb(42, 157, 233)"
                      inactive-color="grey" :inactive-text="$t('healthIns2.yes')" :active-text="$t('healthIns2.no')"
                      inactive-value="はい" active-value="いいえ"></el-switch>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="ruleForm.together === 'いいえ'">
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.before_address_pref')" prop="s_before_address1"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_before_address1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.before_address_pref')">
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.change_post')" prop="change_post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_change_post" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000" :maxlength="8"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.change_address_pref')" prop="change_address1"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_change_address1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.change_address_pref')">
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.before_address')" prop="before_address2"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_before_address2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.before_address')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.change_date')" prop="s_movingDate" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.s_movingDate" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns2.change_date')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.change_address')" prop="s_change_address2"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_change_address2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.change_address')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="ruleForm.together === 'いいえ'">
              <el-form-item :label="$t('healthIns2.change_address_pho')" prop="change_address_frgn"
                style="margin-left:50px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_change_address_frgn" size="mini"
                  style="margin-left:10px;width: 87%;" :placeholder="$t('healthIns2.change_address_pho')"></el-input>
              </el-form-item>
            </el-row>
            <el-row v-if="ruleForm.together === 'いいえ'">
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.remark')" prop="remark" style="margin-left:50px">
                    <el-select v-model="ruleForm.s_remark" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in remark" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.other')" prop="s_other" v-if="ruleForm.s_remark === 'その他'"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_other" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.other')"></el-input>
                    <el-button class="el-icon-info" type="text" @click="otherHint" v-if="ruleForm.s_remark === 'その他'">
                    </el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="addUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <!--edit-->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="70%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition">

        <el-input type="hidden" v-model="ruleForm.id" />

        <el-collapse accordion>
          <el-collapse-item :title="$t('healthIns2.insured_info')" name="1" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.employee_id')" prop="employee_id" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.employee_id" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.employee_id')" readonly>
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.mynum')" prop="mynum" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.mynum" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.mynum')" readonly></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.name')" prop="name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-info" v-model="ruleForm.name" size="mini"
                      style="margin-left:10px;width: 185px" readonly></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.birthday')" prop="birthday" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.birthday" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns2.birthday')"
                      readonly></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-form-item :label="$t('healthIns2.before_address')" prop="before_address1" style="margin-left:50px">
                <el-input prefix-icon="el-icon-info" v-model="ruleForm.address" size="mini"
                  style="margin-left:10px;width: 690px" :placeholder="$t('healthIns2.before_address')" readonly>
                </el-input>
              </el-form-item>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.change_post')" prop="change_post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.change_post" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000" :maxlength="8"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.change_address_pref')" prop="change_address1"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.change_address1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.change_address_pref')">
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.change_date')" prop="movingDate" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.movingDate" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns2.before_address')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.change_address')" prop="change_address2"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.change_address2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.change_address')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-form-item :label="$t('healthIns2.change_address_pho')" prop="change_address_frgn"
                style="margin-left:50px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.change_address_frgn" size="mini"
                  style="margin-left:10px;width: 690px" :placeholder="$t('healthIns2.change_address_pho')"></el-input>
              </el-form-item>
            </el-row>

            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.remark')" prop="remark" style="margin-left:50px">
                    <el-select v-model="ruleForm.remark" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in remark" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.arrange_num')" prop="arrange_num" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.arrange_num" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000" :maxlength="8"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.other')" prop="other" v-if="ruleForm.remark === 'その他'"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.other" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.other')"></el-input>
                    <el-button class="el-icon-info" type="text" @click="otherHint" v-if="ruleForm.remark === 'その他'">
                    </el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>

          <!--Spouse Input -->
          <el-collapse-item :title="$t('healthIns2.spouse')" name="2" style="margin-left:10px">
            <el-row>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.s_mynum')" prop="s_mynum" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.mynum_family" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.mynum')" readonly="readonly">
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.s_name')" prop="s_name" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name_family" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.s_name')" readonly="readonly">
                    </el-input>
                  </el-form-item>

                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.birthday')" prop="s_birthday" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.birthday_family" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns2.birthday')"
                      readonly="readonly">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.s_name_frgn')" prop="s_first_name_kn" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.name_frgn_family" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.s_name_frgn')"
                      readonly="readonly"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="22">
                <div>
                  <el-form-item :label="$t('healthIns2.together')" prop="s_change_address_frgn" label-width="440px"
                    style="margin-left:50px">
                    <el-switch v-model="ruleForm.together" style="margin-left:40px;" active-color="rgb(42, 157, 233)"
                      inactive-color="grey" :inactive-text="$t('healthIns2.yes')" :active-text="$t('healthIns2.no')"
                      inactive-value="はい" active-value="いいえ"></el-switch>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="ruleForm.together === 'いいえ'">
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.before_address_pref')" prop="s_before_address1"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_before_address1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.before_address_pref')">
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.change_post')" prop="change_post" style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_change_post" size="mini"
                      style="margin-left:10px;width: 185px" placeholder="000-0000" :maxlength="8"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.change_address_pref')" prop="change_address1"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_change_address1" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.change_address_pref')">
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.before_address')" prop="before_address2"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_before_address2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.before_address')"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.change_date')" prop="s_movingDate" style="margin-left:50px">
                    <el-date-picker v-model="ruleForm.s_movingDate" size="mini" value-format="yyyy-MM-dd"
                      style="margin-left:10px;width: 185px" type="date" :placeholder="$t('healthIns2.change_date')">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('healthIns2.change_address')" prop="s_change_address2"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_change_address2" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.change_address')"></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="ruleForm.together === 'いいえ'">
              <el-form-item :label="$t('healthIns2.change_address_pho')" prop="change_address_frgn"
                style="margin-left:50px">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_change_address_frgn" size="mini"
                  style="margin-left:10px;width: 87%" :placeholder="$t('healthIns2.change_address_pho')"></el-input>
              </el-form-item>
            </el-row>
            <el-row v-if="ruleForm.together === 'いいえ'">
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.remark')" prop="remark" style="margin-left:50px">
                    <el-select v-model="ruleForm.s_remark" :placeholder="$t('general.select')" size="mini"
                      style="margin-left:10px;width: 185px">
                      <el-option v-for="item in remark" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-form-item :label="$t('healthIns2.other')" prop="s_other" v-if="ruleForm.s_remark === 'その他'"
                    style="margin-left:50px">
                    <el-input prefix-icon="el-icon-edit" v-model="ruleForm.s_other" size="mini"
                      style="margin-left:10px;width: 185px" :placeholder="$t('healthIns2.other')"></el-input>
                    <el-button class="el-icon-info" type="text" @click="otherHint" v-if="ruleForm.s_remark === 'その他'">
                    </el-button>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateUser('ruleForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t("general.cancel")}}</el-button>
      </span>
    </el-dialog>

    <br />
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        labelPosition: "left",
        value: "",
        empList: [{
          id: "",
          employee_id: "",
          name: "",
          name_rm: "",
          name_frgn: "",
          mynum: "",
          birthday: "",
          emp_insuranceID: "",
          post_code: "",
          address1: "",
          address2: "",
          address3: "",


        }],
        empList1: [],
        famList1: [{
          name_family: "",
          name_frgn_family: "",
          mynum_family: "",
          birthday_family: "",
        }],
        ruleForm: {
          id: "",
          change_post: "",
          change_address_frgn: "",
          change_address1: "",
          change_address2: "",
          movingDate: "",
          remark: "",
          other: "",
          together: "",
          s_change_post: "",
          s_change_address_frgn: "",
          s_change_address1: "",
          s_change_address2: "",
          s_movingDate: "",
          s_before_address1: "",
          s_before_address2: "",
          s_remark: "",
          s_other: "",
          employee_id: "",
          arrange_num: "",

          name: "",
          name_rm: "",
          name_frgn: "",
          mynum: "",
          birthday: "",
          address: "",

          name_family: "",
          name_frgn_family: "",
          mynum_family: "",
          birthday_family: "",
        },
        remark: [{
          value: "短期在留",
          label: this.$t("healthIns2.short_term"),
        },
        {
          value: "海外居住",
          label: this.$t("healthIns2.oversea"),
        },
        {
          value: "住民票住所以外の居所",
          label: this.$t("healthIns2.other_resident"),
        },
        {
          value: "その他",
          label: this.$t("healthIns2.other"),
        },
        ],
        together: [{
          value: "はい",
          label: this.$t("healthIns2.yes"),
        },
        {
          value: "いいえ",
          label: this.$t("healthIns2.no"),
        },
        ],
        rules: {
          s_before_address1: [{
            required: true,
            message: this.$t("healthIns2.s_before_address_prefRule"),
            trigger: "blur",
          },],
          s_before_address2: [{
            required: true,
            message: this.$t("healthIns2.s_before_addressRule"),
            trigger: "blur",
          },],
          change_post: [{
            required: true,
            message: this.$t("healthIns2.change_postRule"),
            trigger: "blur",
          },],
          change_address_frgn: [{
            required: true,
            message: this.$t("healthIns2.change_address_phoRule"),
            trigger: "blur",
          },],
          change_address1: [{
            required: true,
            message: this.$t("healthIns2.change_address_prefRule"),
            trigger: "blur",
          },],
          change_address2: [{
            required: true,
            message: this.$t("healthIns2.change_addressRule"),
            trigger: "blur",
          },],
          movingDate: [{
            required: true,
            message: this.$t("healthIns2.moving_dateRule"),
            trigger: "blur",
          },],
          remark: [{
            required: true,
            message: this.$t("healthIns2.remarkRule"),
            trigger: "blur",
          },],
          arrange_num: [{
            required: true,
            message: this.$t("healthIns2.arrange_numRule"),
            trigger: "blur",
          },],
          other: [{
            required: true,
            message: this.$t("healthIns2.otherRule"),
            trigger: "blur",
          },],
        },
        tableData: [],
        search: "",
        dialogVisible: false,
        dialogUpdate: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false,
      };
    },
    methods: {
      searchLocation(fidPostCode) {
        'use strict';
        /**
         * 郵便番号の変更イベント
         */
        // collaboflow.events.on('request.input.fidPostCode.change', function (eventData) {
        // 郵便番号を格納
        var postCode = fidPostCode.replace('-', '');
        if (postCode.length !== 7) {
          return;
        }
        var headers = {};
        var parseType = 'json';

        // 指定された郵便番号で住所を取得する
        // 郵便番号取得
        // https://api-doc.postcode-jp.com/#e0cee72981
        var apiKey = 'urbKBOFBWaFT7Xl5l8c2wQxnc6EqJHf6SkzZ5QC';
        var parameters = '?apiKey=' + apiKey;
        var url = 'https://apis.postcode-jp.com/api/v2/postcodes/' + postCode + parameters;

        this.axios({
          method: "get",
          url: url,
          headers: headers,
          parseType: parseType,
        })
          .then((response) => {

            if (response.status !== 200) {
              throw Error(response);
            }
            var searchResult = response.data;
            // 取得した住所の値を設定
            this.ruleForm.change_address1 = searchResult.pref;
            this.ruleForm.change_address2 = searchResult.city + searchResult.town;
            this.ruleForm.change_address_frgn = searchResult.allAddressFullKana;
          })
          .catch(function (error) {
            // エラーリソース
            // https://api-doc.postcode-jp.com/#ec6399d678
            alert('住所の検索に失敗しました。自分入力してください！');
            return false;
          });
      },
      preview(index, row) {
        var uid = window.localStorage.getItem('LoginUserId');
        window.open("/pdf/健康保険・厚生年金保険 被保険者住所変更届（国民年金第3号被保険者住所変更届)-" + row.name + "uid=" + uid + ".pdf");
      },
      otherHint() {
        this.$notify.info({
          title: this.$t("healthIns2.other"),
          message: this.$t("healthIns2.otherHintMsg"),
        });
      },
      employeeIdSelected() {
        // console.log(this.ruleForm.employee_id);
        let postData = this.qs.stringify({
          employee_id: this.ruleForm.employee_id,
        });
        this.axios({
          method: "post",
          url: "/listFamilyWife",
          data: postData,
        })
          .then((response) => {
            // console.log(response.data);
            this.famList1 = response.data;
            this.ruleForm.name_family = this.famList1.name_family;
            this.ruleForm.name_frgn_family = this.famList1.name_frgn_family;
            this.ruleForm.mynum_family = this.famList1.mynum_family;
            this.ruleForm.birthday_family = this.famList1.birthday_family;
          })
          .catch((error) => {
            console.log(error);
          });
        this.axios({
          method: "post",
          url: "/ListEmpList",
          data: postData,
        })
          .then((response) => {
            // console.log(response.data);
            this.empList1 = response.data;
            this.emp = this.empList1[0];
            this.ruleForm.name = this.emp.name;
            this.ruleForm.name_rm = this.emp.name_rm;
            this.ruleForm.mynum = this.emp.mynum;
            this.ruleForm.birthday = this.emp.birthday;
            this.ruleForm.emp_insuranceID = this.emp.emp_insuranceID;
            this.ruleForm.address = "〒" + this.emp.post_code + " " + this.emp.address1 + this.emp.address2 + this.emp
              .address3;
            this.ruleForm.post_code = this.emp.post_code;
            this.ruleForm.address1 = this.emp.address1;
            this.ruleForm.address2 = this.emp.address2;
            this.ruleForm.address3 = this.emp.address3;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      printPDF(index, row) {
        let postData = this.qs.stringify({
          id: row.id,
        });
        this.axios({
          method: "post",
          url: "/healthIns2PDF",
          data: postData,
        })
          .then((response) => {
            this.handleCurrentChange();
            this.$message({
              type: "success",
              message: this.$t("general.print_completed"),
            });
            setTimeout(() => {
              this.preview(index, row);
            }, 700);
            // console.log(response);
          })
          .catch((error) => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed"),
            });
            console.log(error);
          });
      },
      handleEdit(index, row) {
        this.dialogUpdate = true;
        this.ruleForm = Object.assign({}, row);

      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: this.$t("general.confirm"),
          cancelButtonText: this.$t("general.cancel"),
          type: "warning"
        })
          .then(_ => {
            this.emptyUserData();
            done();
          })
          .catch(_ => { });
      },
      handleDelete(index, row) {
        // console.log(index, row);
        this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: "OK",
          cancelButtonText: this.$t("general.cancel"),
          type: "warning",
        })
          .then(() => {
            let postData = this.qs.stringify({
              id: row.id,
            });
            this.axios({
              method: "post",
              url: "/deleteHealthIns2",
              data: postData,
            })
              .then((response) => {
                this.getPages();
                this.currentPage = 1;
                this.axios
                  .post("/pageHealthIns2")
                  .then((response) => {
                    this.tableData = response.data;
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed"),
                });
                // console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("general.canceled"),
            });
          });
      },
      handleCurrentChange() {
        // console.log(`this.$t("general.current_page"): ${this.currentPage}`);
        let postData = this.qs.stringify({
          page: this.currentPage,
        });
        this.axios({
          method: "post",
          url: "/pageHealthIns2",
          data: postData,
        })
          .then((response) => {
            this.tableData = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      s1_cancel(ruleForm) {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.emptyUserData();
        this.$refs[ruleForm].resetFields();
      },
      cancel() {
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.emptyUserData();
      },
      emptyUserData() {
        this.ruleForm = {
          id: "",
          change_post: "",
          change_address_frgn: "",
          change_address1: "",
          change_address2: "",
          movingDate: "",
          remark: "",
          other: "",
          together: "",
          s_first_name_kn: "",
          s_last_name_kn: "",
          s_first_name: "",
          s_last_name: "",
          s_mynum: "",
          s_birthday: "",
          s_change_post: "",
          s_change_address_frgn: "",
          s_change_address1: "",
          s_change_address2: "",
          s_movingDate: "",
          s_before_address1: "",
          s_before_address2: "",
          s_remark: "",
          s_other: "",
          employee_id: "",
          arrange_num: "",

          name: "",
          name_rm: "",
          name_frgn: "",
          mynum: "",
          birthday: "",
          address: "",

          name_family: "",
          name_frgn_family: "",
          mynum_family: "",
          birthday_family: "",
        };
      },
      addUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              change_post: this.ruleForm.change_post,
              change_address_frgn: this.ruleForm.change_address_frgn,
              change_address1: this.ruleForm.change_address1,
              change_address2: this.ruleForm.change_address2,
              movingDate: this.ruleForm.movingDate,
              remark: this.ruleForm.remark,
              other: this.ruleForm.other,
              together: this.ruleForm.together,
              s_change_post: this.ruleForm.s_change_post,
              s_change_address_frgn: this.ruleForm.s_change_address_frgn,
              s_change_address1: this.ruleForm.s_change_address1,
              s_change_address2: this.ruleForm.s_change_address2,
              s_remark: this.ruleForm.s_remark,
              s_other: this.ruleForm.s_other,
              employee_id: this.ruleForm.employee_id,
              arrange_num: this.ruleForm.arrange_num,
            });
            this.axios({
              method: "post",
              url: "/insertHealthIns2",
              data: postData,
            })
              .then((response) => {
                this.axios
                  .post("/pageHealthIns2")
                  .then((response) => {
                    this.tableData = response.data;
                    this.currentPage = 1;
                    this.$message({
                      type: "success",
                      message: this.$t("general.add_completed"),
                    });
                  })
                  .catch((error) => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.add_failed"),
                    });
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
                // console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      updateUser(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({
              id: this.ruleForm.id,
              change_post: this.ruleForm.change_post,
              change_address_frgn: this.ruleForm.change_address_frgn,
              change_address1: this.ruleForm.change_address1,
              change_address2: this.ruleForm.change_address2,
              movingDate: this.ruleForm.movingDate,
              remark: this.ruleForm.remark,
              other: this.ruleForm.other,
              together: this.ruleForm.together,
              s_change_post: this.ruleForm.s_change_post,
              s_change_address_frgn: this.ruleForm.s_change_address_frgn,
              s_change_address1: this.ruleForm.s_change_address1,
              s_change_address2: this.ruleForm.s_change_address2,
              s_remark: this.ruleForm.s_remark,
              s_other: this.ruleForm.s_other,
              employee_id: this.ruleForm.employee_id,
              arrange_num: this.ruleForm.arrange_num,
            });
            this.axios({
              method: "post",
              url: "/updateHealthIns2",
              data: postData,
            })
              .then((response) => {
                this.handleCurrentChange();
                this.s1_cancel(ruleForm);
                this.$message({
                  type: "success",
                  message: this.$t("general.edit_completed"),
                });
                // console.log(response);
              })
              .catch((error) => {
                this.$message({
                  type: "warning",
                  message: this.$t("general.edit_failed"),
                });
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      getPages() {
        this.axios
          .post("/rowsHealthIns2")
          .then((response) => {
            this.total = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      refreshData() {
        location.reload();
      },
    },
    created() {
      this.axios
        .post("/pageHealthIns2")
        .then((response) => {
          this.show = true
          this.tableData = response.data;
        })
        .catch((error) => {

        });

      this.axios
        .post("/rowsHealthIns2")
        .then((response) => {
          this.total = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios
        .post("/ListEmpListForInsNameChange")
        .then((response) => {
          // console.log(response.data);
          this.empList = response.data;
          // console.log(this.empList);
        })
        .catch((error) => {
          console.log(error);
        });
      // emptyUserData();
    },
  };
</script>


<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }
</style>
<style scoped>
  .search_name {
    width: 200px;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }

  .style1 {
    margin-right: 145px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/HealthIns/HealthIns2.vue